<template>
  <div class="trait" id="trait" :class="this.retail ? 'is-retail' : 'not-retail'">

    <div class="trait-content">

      <div class="trait-header">
        <h2 v-html="$t('trait.headline')" class="trait-sub-headline"></h2>
        <nav class="traits-icon-nav">
          <template v-for="t in traits">
            <div :key="t" class="trait-nav-item" :class="trait === t ? 'active' : 'inactive'">
              <img :src="'/img/traits/' + t + '.svg'" :alt="t" class="trait-icon-nav" @click="changeTrait(t)">
              <p class="trait-icon-name">{{t}}</p>
            </div>
          </template>
        </nav>
      </div>

      <div class="trait-image">
        <div class="trait-next-prev-nav trait-nav-image">
          <button class="btn prev-trait" :disabled="!previousTrait()" @click="changeTrait(previousTrait())" v-html="$t('trait.previous')"></button>
          <button class="btn next-trait" :disabled="!nextTrait()" @click="changeTrait(nextTrait())" v-html="$t('trait.next')"></button>
        </div>
        <picture>
          <source v-if="this.retail" media="(min-width: 1024px)" :srcset="'/img/traits/888x1302_' + trait + '.jpg'">
          <source v-else media="(min-width: 1024px)" :srcset="'/img/traits/888x1005_' + trait + '.jpg'">
          <img :src="'/img/traits/888x774_' + trait + '.jpg'">
        </picture>
      </div>

      <div class="trait-details">
        <div class="trait-icon-holder">
          <img :src="'/img/traits/' + trait + '.svg'" id="icon" :alt="trait" class="trait-icon">
        </div>
        <h1 v-html="trait" class="trait-name"></h1>
        <div class="trait-description-wrapper">
          <p v-html="$t('trait.' + trait.replace('-', ''))" class="trait-description"></p>
          <div class="trait-next-prev-nav trait-nav-description">
            <button class="btn prev-trait" :disabled="!previousTrait()" @click="changeTrait(previousTrait())" v-html="$t('trait.previous')"></button>
            <button class="btn next-trait" :disabled="!nextTrait()" @click="changeTrait(nextTrait())" v-html="$t('trait.next')"></button>
          </div>
          <p class="trait-next-prev-nav-header">view more of your traits</p>
        </div>
      </div>

    </div>

    <div class="trait-products-outer-wrapper">
      <div class="trait-shop-actions" id="popup">
        <a class="shop-popup" href="https://piecesofmeco.com/pages/discount-unlock" target="_blank">
          <h6 class="shop-popup-title">Get <i>10%</i> Off!</h6>
          <p class="shop-popup-subtitle"><i>claim your discount</i></p>
        </a>
      </div>

      <div class="trait-products">
        <template v-for="product in products">
          <div :key="product.id" class="product" @click="selectProduct($event)">

            <a class="product-figure" :href="product.onlineStoreUrl" :style="bckgndImage(product.images.edges[0].node.originalSrc)" target="_blank">
              <img :src="product.images.edges[0].node.originalSrc" :alt="product.images.edges[0].node.altText" class="product-image">
            </a>

            <div class="product-details">
              <h3 class="product-name"><a :href="product.onlineStoreUrl" target="_blank">{{capitalize(product.handle.replace(/-/g, ' '), true)}}</a></h3>
              <a class="product-link" :href="product.onlineStoreUrl" target="_blank">view details >></a>
            </div>
          </div>
        </template>
      </div>
      <!-- <a class="trait-products-title" :href="'https://piecesofmeco.com/collections/'+ trait.toLowerCase()" target="_blank">Shop The {{capitalize(trait.replace('-', ' '))}} Collection</a> -->
      <carousel class="trait-products"
        :navigationEnabled="true"
        :perPage="4"
        :navigationNextLabel="'>'"
        :navigationPrevLabel="'<'"
        :paginationEnabled="false">
        <template v-for="product in products">
          <slide :key="product.id" class="product" @click="selectProduct($event)">

            <a class="product-figure" :href="product.onlineStoreUrl" :style="bckgndImage(product.images.edges[0].node.originalSrc)" target="_blank">
              <img :src="product.images.edges[0].node.originalSrc" :alt="product.images.edges[0].node.altText" class="product-image">
            </a>

            <div class="product-details">
              <h3 class="product-name"><a :href="product.onlineStoreUrl" target="_blank">{{capitalize(product.handle.replace(/-/g, ' '), true)}}</a></h3>
              <a class="product-link" :href="product.onlineStoreUrl" target="_blank">view details >></a>
            </div>
          </slide>
        </template>
      </carousel>

    </div>
  </div>
</template>

<script>
import Shopify from '@/services/shopify'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'trait',
  data () {
    return {
      trait: this.$route.params.trait1,
      traits: [this.$route.params.trait1, this.$route.params.trait2, this.$route.params.trait3, this.$route.params.trait4],
      products: [],
      retail: this.$route.query.retail || window.location.host.split('.')[0] === 'retail'
    }
  },
  mounted () {
    setTimeout(() => this.animate(), 1500)
  },
  components: {
    Carousel,
    Slide
  },
  watch: {
    trait: function (to, from) {
      this.loadProducts()
    }
  },
  methods: {
    changeTrait (to) {
      this.trait = to
      let element = document.getElementById('trait')
      let top = element.offsetTop
      window.scrollTo(0, top)
      document.querySelector('.trait-products').scrollLeft = 0
    },
    nextTrait () {
      var index = this.traits.indexOf(this.trait)
      var next = this.traits[index + 1]
      if (next && next !== this.trait) {
        return next
      }
    },
    previousTrait () {
      var index = this.traits.indexOf(this.trait)
      var previous = this.traits[index - 1]
      if (previous && previous !== this.trait) {
        return previous
      }
    },
    loadProducts () {
      if (!this.retail) { // Don't show products to retailers
        Shopify.getProductsForCategory(this.trait)
          .then(products => {
            this.products = products.data
          })
      }
    },
    capitalize (s, removeTraitName) {
      let trait = this.trait.replace('-', ' ').toLowerCase()
      if (removeTraitName) {
        s = s.toLowerCase().replace(trait, ' ')
      }
      let words = s.split(' ')
      let wordsArray = words.map(word => {
        return word.charAt(0).toUpperCase() + word.slice(1)
      })
      let newString = wordsArray.join(' ')
      return newString
    },
    selectProduct (event) {
      let product = event.target.parentElement.closest('.product')
      let selectedProducts = document.getElementsByClassName('product selected')

      if (product.classList.contains('selected')) {
        for (let i = 0; i < selectedProducts.length; i++) {
          selectedProducts[i].classList.remove('selected')
        }
      } else {
        for (let i = 0; i < selectedProducts.length; i++) {
          selectedProducts[i].classList.remove('selected')
        }
        product.classList.add('selected')
      }
    },
    bckgndImage (src) {
      return 'background-image: url("' + src + '");'
    },
    animate () {
      setTimeout(3500)
      let elem = document.getElementById('popup')
      elem.classList.add('animate')
    }
  },
  created () {
    this.loadProducts()
  }
}
</script>

<style lang="scss" src="../styles/trait.scss"></style>
